<div class="dialog-title">
    <h2 mat-dialog-title>Encontrei {{ itemCount }} cadastros com este {{ docType }}</h2>
    <button aria-label="close dialog" class="material-icons close-icon" (click)="close()">
        close
    </button>
</div>
<mat-dialog-content>
    <div class="content-scrollable">
        <ul class="list-search">
            <li *ngFor="let item of list">
                <div class="list-items" (click)="getItemAndCloseModal(item)">
                    <div title="{{ item.label }}">
                        {{ item.labelTruncated }} <span *ngIf="item.dateRegister">&nbsp;({{item.dateRegister | date:
                            "dd/MM/yyyy 'às' HH:mm"}})</span>
                    </div>
                    <div>
                        <span>{{ item.filledFields }}% preenchido</span>
                        <mat-progress-bar [ngClass]="item.percentRange" [value]="item.filledFields"></mat-progress-bar>
                    </div>
                </div>
            </li>
        </ul>
    </div>
    
</mat-dialog-content>



